import React, {useState} from 'react'
import './CalendarToolbar.styles.scss'
import {
  ButtonGroup,
  Button,
  IconButton,
  TextField,
  InputAdornment,
  Grid,
  Typography,
} from '@material-ui/core'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import _ from 'lodash'
import {RESET} from '../../state/constants'
import {ReservationCalendarMainContext} from '../../context/ReservationCalendarMain'
import useReservationEventsReducer from '../../state/reservation/events/reducer'
import moment from 'moment'
import CloseIcon from '@material-ui/icons/Close'
import SearchIcon from '@material-ui/icons/Search'
import {useContext} from 'reactn'
import {NewCalendarContext} from '../../context/NewCalendar'
import useCalendarViewContext from '../../context/CalendarView'

const classRoot = 'ap-reservation-calendar-toolbar'

export default function CalendarToolbar({label = 'May', date = new Date()}) {
  const [isSearching, setSearching] = useState(false)
  const [search, setSearch] = useState('')
  const {
    realSearch,
    setRealSearch,
    selectedDate,
    calendarView,
    setSelectedDate,
    handleSidebarData,
    setSidebarDateClicked,
    searchCalendardispatch,
  } = React.useContext(ReservationCalendarMainContext)
  const {viewData} = useCalendarViewContext()

  const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  const [events, dispatch] = useReservationEventsReducer()

  const handleSearchText = e => {
    e.preventDefault()
    let value
    if (e.target.value === ' ') {
      value = e.target.value.trim()
    } else {
      value = e.target.value
    }

    setSidebarDateClicked(false)
    setSearch(value)
  }

  const handleSearch = e => {
    if ('Enter' === e.key) {
      if (isSearching) {
        searchCalendardispatch({type: RESET})
        setRealSearch(search)
      } else {
        setSearching(true)
      }
    }
  }

  const handleBlur = e => {
    if (search.trim() === '') {
      setSearching(false)
    }
  }

  const getLabel = () => {
    const date = selectedDate.clone() // clone first to avoid accidental update of selected date
    switch (calendarView) {
      case 'month':
        return (
          <span
            className={'ap-typography ap-typography--lg'}
            style={{color: '#596175'}}
          >{`${date.format('MMMM')} ${date.format('YYYY')}`}</span>
        )
      case 'week':
        const ds = date.clone().startOf('week')
        const de = date.clone().endOf('week')
        const sameMonth = ds.get('month') === de.get('month')
        const sameYear = ds.get('year') === de.get('year')

        return (
          <span className={'ap-typography ap-typography--lg'} style={{color: '#596175'}}>
            {' '}
            {`${ds.format(`MMMM Do${sameYear ? '' : ', YYYY'}`)} - ${de.format(
              `${sameMonth ? '' : 'MMMM '}Do, YYYY`
            )}`}
          </span>
        )
      case 'day':
        return (
          <span
            className={'ap-typography ap-typography--lg'}
            style={{color: '#596175'}}
          >{`${date.format('MMM Do, YYYY')}`}</span>
        )
      default:
        break
    }
    if (calendarView === 'month') {
      return `${date.format('MMMM')}, ${date.year()}`
    }
  }

  const goToBack = () => {
    switch (calendarView) {
      case 'month':
        setSelectedDate(moment(selectedDate).subtract(1, 'months'))
        break
      case 'week':
        setSelectedDate(moment(selectedDate).subtract(1, 'weeks'))
        break
      case 'day':
        setSelectedDate(moment(selectedDate).subtract(1, 'days'))
        break
      default:
        break
    }
  }
  const goToNext = () => {
    switch (calendarView) {
      case 'month':
        setSelectedDate(moment(selectedDate).add(1, 'months'))
        break
      case 'week':
        setSelectedDate(moment(selectedDate).add(1, 'weeks'))
        break
      case 'day':
        setSelectedDate(moment(selectedDate).add(1, 'days'))
        break
      default:
        break
    }
  }

  return (
    <div className={`${classRoot}`}>
      <div className={`${classRoot}__label-group`}>
        <span className="next-icon">{getLabel()}</span>
        <IconButton onClick={goToBack}>
          <KeyboardArrowLeftIcon />
        </IconButton>
        <IconButton onClick={goToNext}>
          <KeyboardArrowRightIcon />
        </IconButton>
      </div>
      <div className={`search-option-body ${isSearching ? 'search-option-body--active' : ''}`}>
        {isSearching && (
          <>
            <input
              className="ap-typography"
              type="text"
              autoFocus
              value={search}
              onChange={handleSearchText}
              onKeyDown={e => handleSearch(e)}
              onBlur={handleBlur}
            />
            <CloseIcon
              style={{cursor: 'pointer'}}
              onClick={() => {
                if (search) {
                  setSearching(false)
                  setRealSearch('')
                  setSearch('')
                }
              }}
              color={!search ? 'disabled' : ''}
            />
            <div>|</div>
          </>
        )}
        <IconButton
          type="submit"
          underline={false}
          aria-label="search"
          disabled={
            (search !== '' && search === realSearch) ||
            (_.isEmpty(viewData?.selectedView?.group_view?.groups) &&
              _.isEmpty(viewData?.selectedView?.group_view?.actions))
          }
          style={{padding: 0, cursor: 'pointer'}}
          onClick={() => {
            if (isSearching === true) {
              setRealSearch(search)
              searchCalendardispatch({type: RESET})
            } else {
              setSearching(true)
            }
          }}
        >
          <SearchIcon />
        </IconButton>
      </div>
    </div>
  )
}
